(() => {
  const ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
  ];
  const STORAGE_KEY = 'unifa_first_touch_attribution';
  let clickTrackingRegistered = false;
  let refreshFrame = 0;

  const pushEvent = (payload) => {
    if (window.Shopify && window.Shopify.designMode) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  const readStoredAttribution = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (_error) {
      return {};
    }
  };

  const collectAttribution = () => {
    const query = new URLSearchParams(window.location.search);
    const stored = readStoredAttribution();
    const values = { ...stored };

    ATTRIBUTION_KEYS.forEach((key) => {
      const currentValue = query.get(key);
      if (currentValue && !values[key]) values[key] = currentValue;
    });

    if (!values.landing_page) values.landing_page = window.location.href;
    values.page_url = window.location.href;
    if (!values.referrer && document.referrer) values.referrer = document.referrer;

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(values));
    } catch (_error) {
      // Form submission remains functional when storage is unavailable.
    }
    return values;
  };

  const populateAttributionFields = (values) => {
    document.querySelectorAll('[data-unifa-attribution]').forEach((field) => {
      const key = field.dataset.unifaAttribution;
      field.value = values[key] || '';
    });

    const query = new URLSearchParams(window.location.search);
    const product = query.get('product');
    const sku = query.get('sku');
    document.querySelectorAll('[data-unifa-product-interest]').forEach((field) => {
      if (!product) return;
      const productInterest = sku ? `${product} / SKU: ${sku}` : product;
      field.value = productInterest;
      field.defaultValue = productInterest;
      field.setAttribute('value', productInterest);
    });
  };

  const formType = (form) => {
    if (form.classList.contains('unifa-track-form--rfq')) return 'rfq';
    if (form.classList.contains('unifa-track-form--contact')) return 'contact';
    return 'contact';
  };

  const registerFormTracking = () => {
    document.querySelectorAll('.unifa-track-form').forEach((form) => {
      if (form.dataset.unifaTrackingBound === 'true') return;
      form.dataset.unifaTrackingBound = 'true';
      let started = false;
      const start = () => {
        populateAttributionFields(collectAttribution());
        if (started) return;
        started = true;
        pushEvent({ event: 'unifa_form_start', form_type: formType(form), page_path: window.location.pathname });
      };
      form.addEventListener('focusin', start, { once: true });
      form.addEventListener('change', start, { once: true });
      form.addEventListener('submit', () => {
        populateAttributionFields(collectAttribution());
        const type = formType(form);
        try {
          sessionStorage.removeItem(`unifa_lead_${type}_${window.location.pathname}`);
        } catch (_error) {
          // Submission is not blocked when storage is unavailable.
        }
        pushEvent({ event: 'unifa_form_submit_attempt', form_type: type, page_path: window.location.pathname });
      });
    });
  };

  const registerSuccessEvents = () => {
    document.querySelectorAll('[data-unifa-form-success]').forEach((message) => {
      if (message.dataset.unifaSuccessTracked === 'true') return;
      message.dataset.unifaSuccessTracked = 'true';
      const type = message.dataset.unifaFormSuccess || 'contact';
      const dedupeKey = `unifa_lead_${type}_${window.location.pathname}`;
      try {
        if (sessionStorage.getItem(dedupeKey)) return;
        sessionStorage.setItem(dedupeKey, '1');
      } catch (_error) {
        // Push once per rendered success state if storage is unavailable.
      }
      pushEvent({ event: 'unifa_generate_lead', form_type: type, page_path: window.location.pathname });
    });
  };

  const registerClickTracking = () => {
    if (clickTrackingRegistered) return;
    clickTrackingRegistered = true;
    document.addEventListener('click', (event) => {
      const element = event.target.closest('[data-unifa-event]');
      if (!element) return;
      pushEvent({
        event: element.dataset.unifaEvent,
        cta_name: element.dataset.unifaCtaName || element.textContent.trim().slice(0, 100),
        cta_location: element.dataset.unifaCtaLocation || 'unknown',
        destination_url: element.href || '',
        form_type: element.dataset.unifaFormType || '',
        page_path: window.location.pathname,
      });
    });
  };

  const init = () => {
    populateAttributionFields(collectAttribution());
    registerFormTracking();
    registerSuccessEvents();
    registerClickTracking();
  };

  const scheduleRefresh = () => {
    window.cancelAnimationFrame(refreshFrame);
    refreshFrame = window.requestAnimationFrame(init);
  };

  ['pushState', 'replaceState'].forEach((methodName) => {
    const original = history[methodName];
    if (typeof original !== 'function') return;
    history[methodName] = function unifaHistoryUpdate(...args) {
      const result = original.apply(this, args);
      window.dispatchEvent(new Event('unifa:navigation'));
      return result;
    };
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('load', scheduleRefresh, { once: true });
  window.addEventListener('pageshow', scheduleRefresh);
  window.addEventListener('popstate', scheduleRefresh);
  window.addEventListener('hashchange', scheduleRefresh);
  window.addEventListener('unifa:navigation', scheduleRefresh);
  document.addEventListener('shopify:section:load', scheduleRefresh);

  [250, 900, 2200].forEach((delay) => {
    window.setTimeout(() => populateAttributionFields(collectAttribution()), delay);
  });
})();
